import { number, string } from "yup";

export class Plantilla {
    id?: string;
    idSistema?: string;
    titulo: string;
    contenido: string;
    descripcion: string;
    paginaDestino: string;
    nombreImagen: string;
    urlImagen: string;
    mostraModal: boolean;
    accion: string;
    urlWeb: string;
    urlVerificacion: string;
    urlRecuperacion: string;
    estado: string;
    ultimoCambio: string;
    mostrarAppNotificacion: string;


    constructor(
        id: string,
        idSistema: string,
        titulo: string,
        contenido: string,
        descripcion: string = '',
        paginaDestino: string = '',
        nombreImagen: string,
        urlImagen: string = '',
        mostraModal: boolean = false,
        accion: string = '',
        urlWeb: string = '',
        urlVerificacion: string = '',
        urlRecuperacion: string = '',
        estado: string = '',
        ultimoCambio: string = '',
        mostrarAppNotificacion: string = ''
    ) {
        this.id = id;
        this.idSistema = idSistema;
        this.titulo = titulo;
        this.contenido = contenido;
        this.descripcion = descripcion;
        this.paginaDestino = paginaDestino;
        this.nombreImagen = nombreImagen;
        this.urlImagen = urlImagen;
        this.mostraModal = mostraModal;
        this.accion = accion;
        this.urlWeb = urlWeb;
        this.urlRecuperacion = urlRecuperacion;
        this.urlVerificacion = urlVerificacion;
        this.estado = estado;
        this.ultimoCambio = ultimoCambio;
        this.mostrarAppNotificacion = mostrarAppNotificacion;
    }

    static ConstruirPorTipoNotificacion(
        plantilla: any
      ) {
        return new Plantilla(
            plantilla.idnmtiponotificacion,
            plantilla.idsistema,
            plantilla.titulo,
            plantilla.plantillatextoenviar,
            plantilla.descripcion,
            "/"+plantilla.pagina,
            plantilla.urlimagen !== null ? plantilla.urlimagen.split('/')[plantilla.urlimagen.split('/').length - 1] : '',
            plantilla.urlimagen ?? '',
            plantilla.mostrarmodal === "N" ? false : true,
            plantilla.urlabrir !== null ? "webPage" : "",
            plantilla.urlabrir ?? "",
            plantilla.urlverificacionestadoobjeto,
            plantilla.urlparadatosplantilla,
            plantilla.estado
        );
        
      }


    setId(id: string): void {
        this.id = id;
    }

    setIdSistema(idSistema: string): void {
        this.idSistema = idSistema;
    }

    // Setter for titulo
    setTitulo(titulo: string): void {
        this.titulo = titulo;
    }

    // Setter for contenido
    setContenido(contenido: string): void {
        this.contenido = contenido;
    }

    // Setter for descripcion
    setDescripcion(descripcion: string): void {
        this.descripcion = descripcion;
    }

    // Setter for paginaDestino
    setPaginaDestino(paginaDestino: string): void {
        this.paginaDestino = paginaDestino;
    }

    // Setter for nombreImagen
    setNombreImagen(nombreImagen: string): void {
        this.nombreImagen = nombreImagen;
    }

    // Setter for urlImagen
    setUrlImagen(urlImagen: string): void {
        this.urlImagen = urlImagen;
    }

    // Setter for mostraModal
    setMostraModal(mostraModal: boolean): void {
        this.mostraModal = mostraModal;
    }

    // Setter for accion
    setAccion(accion: string): void {
        this.accion = accion;
    }

    // Setter for urlWeb
    setUrlWeb(urlWeb: string): void {
        this.urlWeb = urlWeb;
    }

    // Setter for urlVerificacion
    setUrlVerificacion(urlVerificacion: string): void {
        this.urlVerificacion = urlVerificacion;
    }

    // Setter for urlRecuperacion
    setUrlRecuperacion(urlRecuperacion: string): void {
        this.urlRecuperacion = urlRecuperacion;
    }

    getDisplayName(): string {
        return `${this.titulo} - ${this.contenido}`;
    }


    // mapGivenArrray(plantillas: Array<Plantilla>){
    // }

}


